/* eslint-disable react/style-prop-object */

import { FormattedNumber } from 'react-intl';

import { BodyText } from '@garnish/core';

// ─────────────────────────────────────────────────────────────────────────────

export const ProductDetailsCost = (props: Props) => {
  const { costInCents } = props;

  const costInDollars = costInCents / 100;

  return (
    <BodyText sizeMatch={['18']} bold>
      <FormattedNumber value={costInDollars} currency="USD" style="currency" />
    </BodyText>
  );
};

// ─── Types ───────────────────────────────────────────────────────────────────

type Props = {
  costInCents: number;
};
